import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";

interface LoadingProps {
  title?: string;
}

export function Loading({ title = "Loading" }: LoadingProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <CircularProgress size="80" />

      <Typography
        sx={{
          marginTop: "2rem",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}
